import {httpV3Post} from "../network";
import {getJWT, getUserPayloadFromJWT, setJWT} from "./jwt";
import {setAuthkey} from "../user";

/**
 * Refresh token
 *
 * @param emailAddress {string}
 * @param password {string}
 * @return {Promise}
 */
const login = (emailAddress, password) => {
  return httpV3Post("/account/login", {emailAddress, password})
    .then(r => {
      if (200 !== r.status || "success" !== r.data.result) {
        return Promise.reject({response: r});
      }
      // Response content
      const data = r.data;

      // Store JWT
      setJWT(data.data.token);
      // Store authkey
      setAuthkey(data.data.authkey);

      return getUserPayloadFromJWT(getJWT());
    });
};

/**
 * Refresh token
 *
 * @return {Promise}
 */
const refreshToken = () => {
  return httpV3Post("/account/refreshToken")
    .then(r => {
      if (200 !== r.status || "success" !== r.data.result) {
        return Promise.reject({response: r});
      }
      // Response content
      const data = r.data;

      // Store JWT
      setJWT(data.data.token);
      // Store authkey
      setAuthkey(data.data.authkey);

      return getUserPayloadFromJWT(getJWT());
    });
};

export {login, refreshToken};
